import gql from 'graphql-tag'

export const SearchDiagnosesML = gql`
    query SearchDiagnosesML($searchTitle: String!, $searchDescription: String!, $patientId: String, $emrEncounterId: String) {
        searchDiagnosesML(input: { searchTitle: $searchTitle, searchDescription: $searchDescription, patientId: $patientId, emrEncounterId: $emrEncounterId}) {
            diagnoses {
                diagnosis {
                  icdCode
                  description
                  snomedCode
                  billable
                  problemLabel
                }
                score
                children {
                  diagnosis {
                    icdCode
                    description
                    snomedCode
                    billable
                    problemLabel
                  }
                  children {
                    diagnosis {
                      icdCode
                      description
                      snomedCode
                      billable
                      problemLabel
                    }
                    children {
                      diagnosis {
                        icdCode
                        description
                        snomedCode
                        billable
                        problemLabel
                      }
                      children {
                        diagnosis {
                          icdCode
                          description
                          snomedCode
                          billable
                          problemLabel
                        }
                      }
                    }
                  }
                }
              }
              suggestions {
                diagnosis {
                  icdCode
                  description
                  snomedCode
                  billable
                  problemLabel
                }
                score
                children {
                  diagnosis {
                    icdCode
                    description
                    snomedCode
                    billable
                    problemLabel
                  }
                  children {
                    diagnosis {
                      icdCode
                      description
                      snomedCode
                      billable
                      problemLabel
                    }
                    children {
                      diagnosis {
                        icdCode
                        description
                        snomedCode
                        billable
                        problemLabel
                      }
                      children {
                        diagnosis {
                          icdCode
                          description
                          snomedCode
                          billable
                          problemLabel
                        }
                      }
                    }
                  }
                }
              }
        }
    }
`

// Get HCCSuggestions to send to S2 for problem suggestion panel
export const QueryGetHCCSuggestions = gql`
query QueryGetHCCSuggestions($patientId: String, $emrEncounterId: String, $existingDiagnoses: [ExistingDiagnosis], $specialties: [SpecialtyType] ) {
  getHCCSuggestions(input: {
    patientId: $patientId,
    emrEncounterId: $emrEncounterId,
    existingDiagnoses: $existingDiagnoses,
    specialties: $specialties
  }) {
    suggestions {
      diagnosis {
        icdCode,
        description,
        snomedCode,
        snomedDescription,
        hccCode,
        panelRanking, 
        billable,
        problemLabel,
        suggestionType
      }
      suggestionType
    }
  }
}
`
